//
//  SDKDocumentationPageBlockAssets.ts
//  Supernova SDK
//
//  Created by Jiri Trecak.
//
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Imports
import { FrameAlignment } from "../../enums/SDKFrameAlignment";
import { FrameLayout } from "../../enums/SDKFrameLayout";
import { DocumentationLegacyPageBlock, } from "../SDKDocumentationLegacyPageBlock";
import { DocumentationLegacyPageBlockAsset, } from "./SDKDocumentationLegacyPageBlockAsset";
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: -  Object Definition
export class DocumentationLegacyPageBlockAssets extends DocumentationLegacyPageBlock {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model, children) {
        var _a, _b, _c, _d, _e, _f;
        super(model, children);
        const color = (_b = (_a = model.figmaFrameProperties) === null || _a === void 0 ? void 0 : _a.color) !== null && _b !== void 0 ? _b : null;
        this.properties = {
            backgroundColor: color,
            alignment: (_d = (_c = model.figmaFrameProperties) === null || _c === void 0 ? void 0 : _c.alignment) !== null && _d !== void 0 ? _d : FrameAlignment.center,
            layout: (_f = (_e = model.figmaFrameProperties) === null || _e === void 0 ? void 0 : _e.layout) !== null && _f !== void 0 ? _f : FrameLayout.c4,
        };
        this.assets = model.componentAssets.map((f) => new DocumentationLegacyPageBlockAsset(f, color));
    }
}
